<template>
  <div>
    <div class="pageTop1">
      <div class="bg">
        <div style="padding-bottom: 30px">
          <FxedTop></FxedTop>
        </div>
      </div>
      <div class="pageTitle">
        <div class="sort">
          <!-- <div class="active" style="margin-right: 40px; cursor: pointer">
            最新
          </div>
          <div style="cursor: pointer">最热</div> -->
        </div>
        <div class="currentLocation">当前位置：首页 > 精选课程</div>
      </div>
      <!-- 在线课程 -->
      <div class="mian">
        <div>
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="课程年度">
              <el-select v-model="formInline.classYear" placeholder="课程年度">
                <el-option v-for="item in classYear" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="课程类型">
              <el-select v-model="formInline.requiredType" placeholder="必修/选修">
                <el-option label="选修课程" value="2"></el-option>
                <el-option label="必修课程" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="课程类别">
              <el-select v-model="formInline.courseType" placeholder="课程类别">
                <el-option label="公需科目" value="1"></el-option>
                <el-option label="专业科目" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getGroup">查询</el-button>
              <el-button plain @click="resetQuery">重置</el-button>
            </el-form-item>
          </el-form>
          <!-- <div class="title"></div> -->
          <div class="flex-row" v-if="curriculumList.length > 0">
            <div class="itemFlex" v-loading="loading" v-for="(item, index) in curriculumList" :key="index">
              <div class="itemBody">
                <img v-if="item.requiredType == 1" class="itemLogo" src="@/assets/image/必修.png" />
                <img v-if="item.requiredType == 2" class="itemLogo" src="@/assets/image/选修.png" />
                <img class="groupUp" :src="item.logo ? item.logo : noImg" alt="" />
                <div class="groupBottom">
                  <div class="title">{{ item.name }}</div>
                  <div class="bottomGrayText"></div>
                  <div class="groupLecturer">
                    <div>
                      <span style="margin-right: 10px">讲师: {{ item.lecturer }}</span>
                      <span> 学时: {{ item.learnHour }} </span>
                    </div>
                    <div v-if="item.isJoin == 1" class="seeDetails">
                      <div v-if="item.isComplete == 0" @click="detailSel(index)">
                        开始学习
                      </div>
                      <div v-else>已完成课程</div>
                    </div>
                    <div v-else class="seeDetails" @click="addClass(item)">
                      加入课程
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="
                width: 100%;
                display: flex;
                justify-content: end;
                padding: 10px 0;
              ">
              <el-pagination background layout="prev, pager, next" :page-size="formInline.pageSize" :total="totalNum"
                @current-change="handleCurrentChange" @prev-click="handlePrevClick" @next-click="handleNextClick">
              </el-pagination>
            </div>
          </div>
          <div v-else style="text-align: center; line-height: 200px; color: #ccc">
            暂无课程!
          </div>
        </div>
      </div>
    </div>
    <div>
      <Footer></Footer>
      <payment ref="payment" @show="showQrcode" @close="closeQrcode"></payment>
    </div>
  </div>
</template>

<script>
import { IMAGES_PATH } from "@/utils/config2.js";
import { getGroup, buyClass, joinClassGroup } from "@/api/wkApi.js";
import payment from "@/components/payment.vue";
import FxedTop from "@/components/FxedTop";
import Footer from "@/components/Footer";
export default {
  components: {
    FxedTop,
    Footer,
    payment,
  },
  data() {
    return {
      noImg: require("@/assets/noImg.webp"),
      formInline: {
        classYear: 2025,
        requiredType: undefined,
        courseType: undefined,
        pageNo: 1,
        pageSize: 12,
      },
      loading: true,
      navList: [
        {
          title: "公需课程",
          isShow: true,
          categoryCode: "gongxukecheng",
        },
        {
          title: "专业课程",
          isShow: false,
          categoryCode: "zhuanyekecheng",
        },
      ],
      slideshow: IMAGES_PATH + "/images/microlecture/slideshow.png",
      search: IMAGES_PATH + "/images/microlecture/search.png",
      indicatorDots: true,
      indicatorco: "rgba(0, 0, 0, .3)",
      indicatorac: "#000",
      vertical: false,
      autoplay: true,
      interval: 5000,
      duration: 1000,
      userInfo: {},
      curriculumList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      inputValue: "",
      userCurriculum: {},
      courseList: {},
      marginT: 0,
      tipText: "暂无课程",
      titleArray: ["最新更新", "浏览量", "开课时间", "价格"],
      titleIndex: 0,
      categoryCode: "gongxukecheng", //gongxukecheng
      totalNum: 0,
      classYear: this.getYearsDesc(2016),

    };
  },
  created() {
    this.getGroup();
  },
  methods: {
    getYearsDesc(startYear = 2018) {
      const current = new Date().getFullYear();
      const years = [];
      for (let y = current; y >= startYear; y--) years.push(y);
      return years;
    },

    // 加入课程
    async addClass(item) {
      this.loading = true;
      const res = await joinClassGroup({
        classGroupId: item.classGroupId,
      });
      if (res.code == 200) {
        item.isJoin = 1;
        this.loading = false;
        this.$message.success(res.result);
      } else {
        this.$message.warning("请先登录系统!");
      }
    },
    handleCurrentChange(val) {
      console.log("handleCurrentChange");
      console.log(val);
      this.formInline.pageNo = val;
      this.getGroup();
    },
    handlePrevClick(val) {
      console.log("handlePrevClick");
      console.log(val);
      this.formInline.pageNo = val;
      this.getGroup();
    },
    handleNextClick(val) {
      console.log("handleNextClick");
      console.log(val);
      this.formInline.pageNo = val;
      this.getGroup();
    },
    resetQuery() {
      this.formInline = {
        classYear: 2025,
        requiredType: undefined,
        courseType: undefined,
        pageNo: 1,
        pageSize: 12,
      };
      this.getGroup();
    },

    // 获取课程列表
    async getGroup(params) {
      try {
        this.curriculumList = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
        this.loading = true;
        let res = await getGroup({ ...this.formInline });
        console.log(res, 'res');
        this.loading = false;
        if (!res.result && res.message) {
          this.curriculumList = []
          return this.$message.warning(res.message);
        }
        if (res.result.total == 0 && params.searchKeyword) {
          this.$message.warning("没有搜索到相关课程");
        }
        if (res.result.records) {
          res.result.records.forEach((item) => {
            if (item.logo) {
              item.logo = item.logo.replace(
                "https://xzzhuanji.cn/ework/",
                "https://zwyun.xzzhuanji.cn:18443/zhuanji/"
              );
              item.logo = item.logo.replace("/202508", "");
            }

            if (item.logoBase64) {
              item.logo = `data:image/jpeg;base64,${item.logoBase64}`
            }
          });
        }
        this.curriculumList = res.result.records;
        this.totalNum = res.result.total;
      } catch (error) { }
    },
    // 购买课程
    async goumai(item) {
      let token = localStorage.getItem("token");
      if (!token) {
        return;
      }
      this.$Loading.service({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let res = await buyClass({ classGroupIds: item.id });
      if (res.code == 200) {
        this.$refs.payment.generateQRCode(
          res.result.payParams.codeUrl,
          this.userCurriculum.id,
          () => {
            this.$Loading.service().close();
          }
        );
      } else {
        this.$message.warning(res.message);
      }
    },
    showQrcode(msg) {
      console.log(msg);
    },

    closeQrcode(msg) {
      console.log(msg);
    },
    emitChangeSearch(value) {
      let params = {
        searchKeyword: value,
      };
      this.loading = true;
      this.curriculumList = [{}, {}, {}, {}, {}, {}];
      this.getGroup(params);
    },
    handleNavList(item) {
      this.navList.forEach((item) => {
        item.isShow = false;
      });
      this.categoryCode = item.categoryCode;
      item.isShow = true;
      this.loading = true;
      this.curriculumList = [{}, {}, {}, {}, {}, {}];
      this.getGroup();
    },
    toHomePage(item) {
      this.$router.push({
        path: "/course/homePage",
        query: { groupId: item.id },
      });
    },
    selectCourse(e) {
      this.$message.warning("暂未开放，敬请期待");
    },

    titleSel(index) {
      this.titleIndex = index;
    },

    detailSel(index) {
      this.$router.push({
        path: "/courseDetails",
        query: { classGroupId: this.curriculumList[index].classGroupId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.groupLecturer {
  display: flex;
  justify-content: space-between;

  font-weight: 400;
  font-size: 14px;
  color: #9b9b9b;

  .seeDetails {
    cursor: pointer;
    color: #3465b8;
  }
}

.mian {
  .title {
    display: flex;
    align-items: flex-end;
    position: relative;
    margin-bottom: 20px;

    .zhuangshi {
      position: absolute;
      left: 0;
      top: -10px;
    }

    .name {
      font-weight: bold;
      font-size: 30px;
      color: #0d6fc2;
      line-height: 42px;
      text-align: left;
      font-style: normal;
      padding-left: 10px;
      margin-right: 10px;
    }

    .dynamic {
      font-weight: normal;
      font-size: 14px;
      color: #9b9b9b;
    }
  }

  .flex-row {
    display: flex;
    flex-wrap: wrap;

    .itemFlex {
      width: 317px;
      border-radius: 5px;
      overflow: hidden;
      margin-right: 30px;
      margin-bottom: 30px;

      &:nth-child(4n) {
        margin-right: 0;
      }
    }

    .itemBody {
      display: flex;
      background: white;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;

      .itemLogo {
        position: absolute;
        left: -3px;
        top: -3px;

        width: 80px;
        height: 80px;
      }

      .groupUp {
        width: 380px;
        height: 220px;
        background: #d8d8d8;
        margin-bottom: 10px;
      }

      .groupBottom {
        width: 92%;
        display: flex;
        flex-direction: column;
        padding-bottom: 10px;
        position: relative;

        .title {
          width: 320px;
          font-weight: normal;
          font-size: 18px;
          color: #4a4a4a;
          margin-bottom: 10px;
          // 超出两行显示...
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          /* 限制显示的行数 */
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .bottomGrayText {
          font-weight: 400;
          font-size: 16px;
          color: #9b9b9b;
          // 超出1行显示...
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .bottomPrice {
          font-weight: normal;
          font-size: 18px;
          color: #7ed321;
        }

        .bottomPrice2 {
          font-weight: normal;
          font-size: 18px;
          color: #d91715;
        }
      }
    }
  }
}
</style>
